var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHideDrawer = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 7 14 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M18 7h4v1h-3v14h3v1h-4zm-9.415 8.584A.59.59 0 0 1 8 15c0-.322.268-.584.585-.584h5.466l-2.136-2.123a.564.564 0 0 1 .799-.795l3.12 3.104a.56.56 0 0 1 0 .794l-3.12 3.105a.566.566 0 0 1-.8 0 .56.56 0 0 1 0-.795l2.137-2.123z"
})));
export default SvgHideDrawer;